// Copy-to-clipboard for FCC share links.
//
// Delegated from the document so it covers rows rendered inside any tab, and
// keeps working after a redirect re-renders the table. Any element carrying
// data-fcc-copy="<text>" becomes a copy button.

const FEEDBACK_MS = 1500;
const FAILED_CLASS = "is-copy-failed";

// The message is read by CSS through attr(), so success and failure share one
// bubble. The timer handle lives on the element rather than in a data attribute
// so it never leaks into the markup.
function showFeedback(button, message, failed = false) {
  button.dataset.fccCopyFeedback = message;
  button.classList.toggle(FAILED_CLASS, failed);

  window.clearTimeout(button.fccCopyTimer);
  button.fccCopyTimer = window.setTimeout(() => {
    delete button.dataset.fccCopyFeedback;
    button.classList.remove(FAILED_CLASS);
  }, FEEDBACK_MS);
}

// navigator.clipboard needs a secure context and a focused document. Fall back
// to a throwaway textarea so copying still works over plain http on an
// internal host.
function legacyCopy(text) {
  const scratch = document.createElement("textarea");
  scratch.value = text;
  scratch.setAttribute("readonly", "");
  scratch.style.position = "absolute";
  scratch.style.left = "-9999px";
  document.body.appendChild(scratch);
  scratch.select();

  let copied = false;
  try {
    copied = document.execCommand("copy");
  } catch (error) {
    copied = false;
  }

  document.body.removeChild(scratch);
  return copied;
}

// Last resort: if the browser refuses to write to the clipboard, select the
// link so the admin can copy it by hand instead of clicking into silence.
function selectFallback(button) {
  const link = button.closest(".fcc-share-cell")?.querySelector("code");
  if (link) {
    const range = document.createRange();
    range.selectNodeContents(link);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  const shortcut = navigator.platform.startsWith("Mac") ? "⌘C" : "Ctrl+C";
  showFeedback(button, `Press ${shortcut}`, true);
}

function copy(button, text) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(
      () => showFeedback(button, "Copied"),
      () => {
        if (legacyCopy(text)) showFeedback(button, "Copied");
        else selectFallback(button);
      }
    );
    return;
  }

  if (legacyCopy(text)) showFeedback(button, "Copied");
  else selectFallback(button);
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-fcc-copy]");
  if (!button) return;

  event.preventDefault();

  const text = button.getAttribute("data-fcc-copy");
  if (text) copy(button, text);
});
